import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import Booking_detail from "./views/Booking_detail.vue";
import User from "./views/User.vue";
import Main from "./container/Main.vue";
import Geofence from "./views/Geofence.vue";
import Calendar from "./views/Calendar.vue";
import UserApproval from "./views/UserApproval.vue";
import Request from "./views/Request.vue";
import AssetManagement from "./views/AssetManagement.vue";
import CompanyProfile from "./views/CompanyProfile.vue";
import MyBooking from "./views/MyBooking.vue";
import BookNew from "./views/BookNew.vue";
import EmailTemplate from "./views/EmailTemplate.vue";
import TestBookTable from "./views/TestBookTable.vue";
import UserList from "./views/UserList.vue";
import PopularAddress from "./views/PopularAddress.vue";
import Message from "./views/Message.vue";
import SwopVehicle from "./views/SwopVehicle.vue";
import Report from "./views/Report.vue";
import AssetManager from "./views/AssetManager.vue";
import AssetType from "./views/AssetType.vue";
import AssetGroup from "./views/GroupManagement.vue";
import VehicleMaintenance from "./views/VehicleMaintenance.vue";
import MyProfile from "./views/MyProfile.vue";
import ResetPassword from "./views/ResetPassword.vue";
import ReportsPage from "./reports/Page.vue";

Vue.use(Router);

export default new Router({
  mode: "hash",
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      redirect: "/book",
      name: "Main",
      component: Main,
      children: [
        {
          path: "/user",
          component: User,
          name: "User",
        },
        {
          path: "/user_approval",
          component: UserApproval,
          name: "User Approval",
        },
        {
          path: "/geofence",
          name: "Geofence",
          component: Geofence,
        },
        {
          path: "/calendar",
          name: "Calendar",
          component: Calendar,
        },
        {
          path: "/request",
          name: "Recurrence Booking Request",
          component: Request,
        },
        {
          path: "/asset_management",
          name: "Asset Management",
          component: AssetManagement,
        },
        {
          path: "/company_profile",
          name: "Company Profile",
          component: CompanyProfile,
        },
        {
          path: "/booking_list",
          name: "Booking List",
          component: MyBooking,
        },
        {
          path: "/book",
          name: "New Booking",
          component: BookNew,
        },
        {
          path: "/book/:book_id",
          name: "Edit Booking",
          component: BookNew,
        },
        {
          path: "/email_template",
          name: "Email Template",
          component: EmailTemplate,
        },
        {
          path: "/test_booktable",
          name: "Booking Table",
          component: TestBookTable,
        },
        {
          path: "/user_list",
          name: "User List",
          component: UserList,
        },
        {
          path: "/popular_address",
          name: "Popular Address Management",
          component: PopularAddress,
        },
        {
          path: "/swop_vehicle",
          name: "Swap Vehicle",
          component: SwopVehicle,
        },
        {
          path: "/swop_vehicle/:vehicle_id/:start/:end",
          name: "Swap Vehicle",
          component: SwopVehicle,
        },
        {
          path: "/asset_manager",
          name: "Asset Manager",
          component: AssetManager,
        },
        {
          path: "/asset_type",
          name: "Asset Type",
          component: AssetType,
        },
        {
          path: "/asset_group",
          name: "Asset Group",
          component: AssetGroup,
        },
        {
          path: "/vehicle_service",
          name: "Vehicle Maintenance",
          component: VehicleMaintenance,
        },
        {
          path: "/my_profile",
          name: "My Profile",
          component: MyProfile,
        },
        {
          path: "/report",
          name: "Report",
          component: Report,
        },
        {
          path: "/reports",
          name: "Reports",
          component: ReportsPage,
        },
      ],
    },
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/register/:hash",
      name: "register",
      component: Register,
      props(route) {
        return route.query || {}
      }
    },
    {
      path: "/booking_detail/:book_id",
      name: "book_detail",
      component: Booking_detail,
    },
    {
      path: "/reset_password/:email_token",
      name: "reset_password",
      component: ResetPassword,
    },
    {
      path: "/message",
      name: "message",
      component: Message,
    },
  ],
});
